export const THEME_LIGHT = 'LIGHT';
export const THEME_DARK = 'DARK';
